import React from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import PreferencesWrapper from './components/PreferencesWrapper';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key: string, options?) => translate('preferences', key, options);

const Preferences: React.FC = () => {
  const omitRoutes = useTrialUserOmitRoutes();
  return (
    <>
      <SectionHeader title={t('header')} omitRoutes={omitRoutes} />
      <PreferencesWrapper />
    </>
  );
};

export default Preferences;
